import moment from 'moment';
import { IOpportunityResponse } from '@joc/api-gateway';

import { Item } from '../UploadSeveralPhotos/ItemPreview';

export function convertFromStringToItem(filePathes: Array<string>): Array<Item> {
	return filePathes.map(path => ({
		id: path,
		src: path,
		isChecked: false,
		isNew: false,
	}));
}

export const getFormInitialValues = (opportunityData: IOpportunityResponse, userId?: number) => {
	return {
		...opportunityData,
		user: Number(opportunityData.user?.id),
		opportunityName: opportunityData.opportunityName,
		opportunityDescription: opportunityData.opportunityDescription,
		filePathes: convertFromStringToItem(opportunityData!.filePathes),
		endTime: +moment.duration(opportunityData?.duration, 'seconds').asHours(),
		gender: undefined,
		tagId: opportunityData.tagId ? Number(opportunityData.tagId) : null,
		organisationId: opportunityData.organisation?.id,
	};
};

export const getVolunteerFullName = (oppo?: IOpportunityResponse) => {
	const { volunteers } = oppo ?? {};
	const firstVolunteer = volunteers?.[0];
	const firstName = firstVolunteer?.firstName || '';
	const lastName = firstVolunteer?.lastName || '';
	return `${firstName} ${lastName}`;
};
